export default __webpack_public_path__ + "static/media/attach_money.deb446d5.svg";